var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownSmall = function SvgChevronDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.295 9a.998.998 0 00-1.41-.001L12 12.875 8.115 9a.998.998 0 00-1.41 1.412l4.588 4.587a1 1 0 001.414 0l4.588-4.587a.998.998 0 000-1.411z"
  })));
};
export default SvgChevronDownSmall;